export default "__VITE_ASSET__Cq3wt1xB__"